
import Pagination from "@/components/tables/Pagination";

const AssignmentContentContainer = ({
    children,
    page,
    pageSize,
    total,
    onPageChange,
    onPageSizeChange
}: {
    children: React.ReactNode;
    page: number;
    pageSize: number;
    total: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
}) => (
    <div className="space-y-4 min-h-0 grow flex-1 flex flex-col">
        <div className="gap-2 min-h-0 grow flex flex-col">{children}</div>

        <Pagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
        />
    </div>
);

export default AssignmentContentContainer;
